import { render, staticRenderFns } from "./Wiki.vue?vue&type=template&id=119cff70&scoped=true"
import script from "./Wiki.vue?vue&type=script&lang=ts"
export * from "./Wiki.vue?vue&type=script&lang=ts"
import style0 from "./Wiki.vue?vue&type=style&index=0&id=119cff70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119cff70",
  null
  
)

export default component.exports